import { render, staticRenderFns } from "./menu-bar.vue?vue&type=template&id=2b2e8d22&"
import script from "./menu-bar.vue?vue&type=script&lang=js&"
export * from "./menu-bar.vue?vue&type=script&lang=js&"
import style0 from "./menu-bar.vue?vue&type=style&index=0&id=2b2e8d22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports